import type { StaticImageData } from "next/image";
import Image from "next/image";

export const SplashImageSlimMinimalFade = ({
  src,
}: {
  src: StaticImageData;
}) => {
  return (
    <div
      className={
        "absolute left-0 top-0 -z-[1] h-[65vh] max-h-[1040px] w-full duration-1000 animate-in fade-in gradient-mask-b-70"
      }
    >
      <div
        className={"absolute right-0 h-full w-full max-w-[2000px] duration-1000 animate-in fade-in"}
      >
        <Image
          priority={true}
          placeholder="blur"
          src={src}
          fill={true}
          className={
            "object-cover object-[right_40%] gradient-mask-l-60 sm:object-[right_50%] md:object-[right_40%] lg:object-[right_32%]"
          }
          alt={""}
        />
      </div>

      {/* gradient */}

      <div
        className="absolute z-[1] h-full w-full duration-1000 animate-in fade-in"
        style={{
          backgroundImage: `
      linear-gradient(240deg, rgba(2, 2, 2, 0.2) 0%, rgba(2, 2, 2, 0.1) 30%), 
      linear-gradient(180deg, rgba(2, 2, 2, 0.7) 0%, rgba(2, 2, 2, 0.1) 30%), 
      linear-gradient(120deg, rgba(2, 2, 2, 0.4) 0%, rgba(2, 2, 2, 0.1) 40%), 
      linear-gradient(90deg, rgba(2, 2, 2, 0.7) 0%, rgba(2, 2, 2, 0.1) 50%)`,
        }}
      />
    </div>
  );
};
